import { useState } from "react";
import { Box, Slide, Tooltip } from "@mui/material";
import { keyframes } from "@mui/system";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import AuctionFilter from "../components/Auction/AuctionFilter";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  sidebarContainer: {
    position: "relative",
    height: "100%",
    display: "flex",
  },
  sidebar: {
    minWidth: "300px",
    width: "25vw",
    maxWidth: "350px",
    height: "100%",
    position: "relative",
    boxShadow: "4px 0 10px rgba(0, 0, 0, 0.1)",
    backgroundColor: theme.palette.background.paper,
  },
}));

// Animation keyframes
const bounceRight = keyframes`
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(3px);
  }
`;

const SidebarToggleButton = ({ mobileOpen, setMobileOpen }) => {
  const [isHovered, setIsHovered] = useState(false);

  if (mobileOpen) return null; // Don't show the button when sidebar is open

  return (
    <div
      style={{
        background: "transparent",
        height: "48px",
        width: "48px",
        marginTop: "2rem",
        zIndex: 2,
        position: "absolute",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "0 24px 24px 0",
        // boxShadow: "2px 2px 8px rgba(0,0,0,0.2)",
        cursor: "pointer",
        transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
        transform: isHovered ? "scale(1.05)" : "scale(1)",
        "&:hover": {
          width: "52px",
        },
      }}
      onClick={() => setMobileOpen(true)}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <Tooltip title="View filters" arrow placement="left">
        <KeyboardDoubleArrowRightIcon
          sx={{
            fontSize: "1.8rem",
            color: "linear-gradient(135deg, #3a5fe5 0%, #1a43c4 100%)",
            animation: `${bounceRight} 1.5s infinite ease-in-out`,
            filter: "drop-shadow(0 2px 2px rgba(0,0,0,0.3))",
            transition: "transform 0.2s ease",
            transform: isHovered ? "scale(1.1)" : "scale(1)",
          }}
        />
      </Tooltip>
    </div>
  );
};

const SidebarComponent = ({ mobileOpen, setMobileOpen }) => {
  const classes = useStyles();

  return (
    <Box className={classes.sidebarContainer}>
      <Slide direction="right" in={mobileOpen} mountOnEnter unmountOnExit>
        <Box className={classes.sidebar}>
          <AuctionFilter
            filterChange={true}
            setEventIdFilter={() => {}}
            eventIdFilter={[]}
            setCountryId={1}
            setStateId={1}
            auctionIds={[]}
            setAuctionId={() => {}}
            setMobileOpen={setMobileOpen}
          />
        </Box>
      </Slide>
      <SidebarToggleButton
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />
    </Box>
  );
};

export default SidebarComponent;
